import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifyEmailWithToken } from '../api';
import { EmailVerified } from '../../../modules/SignIn/components/EmailVerified/EmailVerified';
import Button from '../../../shared/ui/button/button';
import { useIntl } from 'react-intl';

import styles from './verify-email.module.css';

export const VerifyEmail = () => {
	const intl = useIntl();
	const location = useLocation();
	const navigate = useNavigate();
	const [isVerifying, setIsVerifying] = useState(true);
	const [verificationError, setVerificationError] = useState(null);
	const [isVerified, setIsVerified] = useState(false);

	useEffect(() => {
		const verifyToken = async () => {
			const searchParams = new URLSearchParams(location.search);
			const token = searchParams.get('token');

			if (!token) {
				setVerificationError(intl.formatMessage({ id: 'VerifyEmailId4' }));
				setIsVerifying(false);
				return;
			}

			try {
				const result = await verifyEmailWithToken(token);

				if (result.success) {
					setIsVerified(true);
				} else {
					setVerificationError(
						result.error || intl.formatMessage({ id: 'VerifyEmailId5' }),
					);
				}
			} catch (error) {
				setVerificationError(intl.formatMessage({ id: 'VerifyEmailId6' }));
			} finally {
				setIsVerifying(false);
			}
		};

		verifyToken();
	}, [intl, location.search]);

	if (isVerifying) {
		return (
			<div className={styles.container}>
				<div className={styles.card}>
					<div className={styles.loading}>
						<div className={styles.spinner}></div>
						<p>{intl.formatMessage({ id: 'VerifyEmailId1' })}</p>
					</div>
				</div>
			</div>
		);
	}

	if (verificationError) {
		return (
			<div className={styles.container}>
				<div className={styles.card}>
					<div className={styles.errorContainer}>
						<div className={styles.errorIcon}>✕</div>
						<h1 className={styles.errorTitle}>
							{intl.formatMessage({ id: 'VerifyEmailId2' })}
						</h1>
						<p className={styles.errorMessage}>{verificationError}</p>
						<Button onClick={() => navigate('/sign-in')}>
							{intl.formatMessage({ id: 'VerifyEmailId3' })}
						</Button>
					</div>
				</div>
			</div>
		);
	}

	if (isVerified) {
		return <EmailVerified />;
	}

	return null;
};
